var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tti-module"},[(_vm.config.content.length != 0)?_c('div',{staticClass:"tti-module-content"},_vm._l((_vm.config.content),function(profile,i){return _c('tti-sub',{key:i,attrs:{"id":'team-sub-'+i,"i":i,"config":profile}})}),1):_c('h3',[_vm._v("Please double click me...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }